// Module
var code = "<td class=\"timewriting-table-column__value description\"> <span data-bind=\"text: _cell.Value\"></span> </td>";
// Exports
export default code;